module.exports = __webpack_public_path__ + "static/media/giftsReceived_100_250.cc7b999c.png";